import React, { useEffect, useState } from "react";
import { api, API } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Megaphone, X } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const SEEN_KEY = "hikmah_dismissed_announcements";

function readSeen() {
  try { return JSON.parse(localStorage.getItem(SEEN_KEY) || "[]"); } catch { return []; }
}
function writeSeen(ids) {
  try { localStorage.setItem(SEEN_KEY, JSON.stringify(ids.slice(-200))); } catch {}
}

export default function AnnouncementBanner() {
  const { tx } = useLanguage();
  const { user } = useAuth();
  const [list, setList] = useState([]);
  useEffect(() => {
    // Only fetch when authenticated
    if (!user) return;
    api.get("/announcements").then((r) => {
      const seen = readSeen();
      setList((r.data || []).filter((a) => !seen.includes(a.id)));
    }).catch(() => {});
  }, [user]);

  const dismiss = (id) => {
    writeSeen([...readSeen(), id]);
    setList((l) => l.filter((a) => a.id !== id));
  };

  if (list.length === 0) return null;

  return (
    <div className="space-y-2 mb-5" data-testid="announcement-banners">
      {list.map((a) => (
        <div key={a.id} className="rounded-2xl border border-gold-500/50 bg-gold-500/10 px-4 py-3 flex items-start gap-3" data-testid={`ann-banner-${a.id}`}>
          <div className="h-8 w-8 rounded-full bg-gold-500/30 text-gold-600 grid place-items-center shrink-0 mt-0.5">
            <Megaphone className="h-4 w-4" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-display font-semibold text-forest-700">{tx(a.title)}</div>
            <p className="text-sm text-foreground/85 leading-relaxed mt-0.5">{a.body}</p>
            {a.created_by_name && <div className="text-[11px] text-muted-foreground mt-1">— {a.created_by_name}</div>}
          </div>
          <button onClick={() => dismiss(a.id)} className="p-1.5 rounded-lg hover:bg-gold-500/20 text-gold-700" data-testid={`ann-dismiss-${a.id}`}>
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
